import { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Pagination from "../pagination/paginationView";
import { fetchAppUsersList } from "../../action/userApi";
import filerIcon from "../../assets/images/Up_Down.svg";
import infoBtn from "../../assets/images/info-circle.svg";
import editBtn from "../../assets/images/edit_btn.svg";
import { Loader } from "../../components/loader";

const AppUsersList = ({
  searchValue,
  sort,
  setSort,
  setOrder,
  order,
  handleRoleChange,
  roleData,
  refresh,
  setAssignDepartment,

}) => {
  const navigate = useNavigate();
  const [appUserList, setAppUserList] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalData, setTotalData] = useState();
  const [loading, setLoading] = useState(false);

  const getAppUserData = async () => {
    setLoading(true);
    const response = await fetchAppUsersList(
      pageNo,
      pageSize,
      searchValue,
      sort,
      order
    ); // Adjust 10 to the desired number of items per page
    setLoading(false);
    if (response.status) {
      setAppUserList(response.data?.data);
      setTotalData(response.data.count);
    }
  };

  useEffect(() => {
    getAppUserData();
  }, [pageNo, pageSize, searchValue, sort, order, refresh]);
  useEffect(() => {
    getAppUserData();
    console.log(refresh, "refresh data paased from props")
  }, [refresh]);

  return (
    <div className="table-wrapper">
      <table className="payout_table upi-mandate_table">
        <thead>
          <tr className="tableHead">
            <th className="thHeader">
              <div className="payoutHead hndIcon">
                Name
                <img
                  src={filerIcon}
                  onClick={() => {
                    setSort("name");
                    setOrder(order == 1 ? -1 : 1);
                  }}
                  alt="filter"
                />
              </div>
            </th>
            <th className="thHeader">
              <div className="payoutHead hndIcon">Email</div>
            </th>
            <th className="thHeader">
              <div className="payoutHead hndIcon">Mobile No</div>
            </th>
            {/* <th className="thHeader">
        <div className="payoutHead hndIcon">Place</div>
      </th> */}
            <th className="thHeader">
              <div className="payoutHead hndIcon">Address</div>
            </th>
            <th className="thHeader">
              <div className="payoutHead hndIcon">Role</div>
            </th>
            <th className="thHeader">
              <div className="payoutHead hndIcon">Joining Date</div>
            </th>
            <th className="thHeader">
              <div className="payoutHead hndIcon">Assigned deptartment</div>
            </th>
            <th className="thHeader">
              <div className="payoutHead hndIcon">Action</div>
            </th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={12} className="text_center">
                <Loader />
              </td>
            </tr>
          ) : (
            <>
              {appUserList?.length > 0 ? (
                appUserList?.map((item) => (
                  <tr key={item?._id}>
                    <td>{item?.name}</td>
                    <td>{item?.email || "-"}</td>
                    <td>{item?.mobile}</td>
                    <td>
                      {" "}
                      <div className="userAddress_col">
                        {item?.addresses?.gaon}, {item?.addresses?.block},{" "}
                        {item?.addresses?.district}, {item?.addresses?.state}{" "}
                      </div>
                    </td>
                    <td>
                      <select
                        size="sm"
                        ariaLabel="Role"
                        onChange={(e) =>
                          handleRoleChange(item._id, e.target.value)
                        }
                        value={item.role}
                      >
                        <option>{item.role}</option>
                        {roleData
                          .filter((data) => data.name !== item.role)
                          .map((i) => (
                            <option key={i._id} value={i._id}>
                              {i.name}
                            </option>
                          ))}
                      </select>
                    </td>
                    <td>{moment(item?.createdAt).format("DD/MM/YYYY")}</td>
                    <td>
                      {item?.departmentDetails?.name ? item?.departmentDetails?.name :
                        <div className="d-flex">
                          <buttun className="btn btn_primary " onClick={() =>
                            setAssignDepartment(item)}> Assign</buttun></div>}
                    </td>
                    <td>
                      <div className="d-flex align-items-center gap-10">
                        {item?.role.toLowerCase() === "user" ?
                          <>
                            {item?.departmentDetails?.name ?
                              <img
                                src={editBtn}
                                className="i_button"
                                onClick={() =>
                                  setAssignDepartment(item)}
                                alt="Edit"
                              /> : <div className="wd__20"></div>}
                          </> :
                          <div className="wd__20"></div>}
                        <img
                          src={infoBtn}
                          className="i_button ms-2"
                          onClick={() => {
                            navigate(`/user/profile/${item._id}`);
                          }}
                          alt="info"
                        />

                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colspan="12">
                    <div className="text-center">
                      No data available</div>
                  </td>
                </tr>
              )}
            </>
          )}
        </tbody>
      </table>
      {appUserList.length > 0 ? (
        <Pagination
          currentPage={pageNo}
          totalCount={totalData}
          pageSize={pageSize}
          onPageChange={(page) => setPageNo(page)}
          changePageSize={(page) => {
            setPageSize(page);
            setPageNo(1);
          }}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default AppUsersList;
